import React, { useState, useEffect } from "react"
import moment from "moment"
export default function Clock({ hour, onHourChange }) {
  const [time, set] = useState(+new Date())
  var timer = setTimeout(() => {
    let h = moment()
      .subtract("hour", 1)
      .hours()
    if (h !== hour) {
      onHourChange(h)
      return
    }
    set(+new Date())
  }, 1000)
  useEffect(() => {
    return () => {
      clearTimeout(timer)
    }
  }, [timer])
  return (
    <div
      style={{
        position: "absolute",
        right: 10,
        top: 10,
        width: 71,
        height: 21,
        background: "rgba(0,0,0,0.8)",
        borderRadius: 4,
        zIndex: 5,
        textAlign: "center",
        lineHeight: "21px",
      }}
    >
      {moment(time).format("HH:mm:ss")}
    </div>
  )
}
